import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { motion } from 'framer-motion';

// Logo Import

export default function Example() {
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
  };

  return (
    isVisible && (
      <motion.div
        initial={{ opacity: 0, translateY: -20, scale: 0.9 }}
        animate={{ opacity: 1, translateY: 0, scale: 1 }}
        exit={{ opacity: 0, translateY: -20, scale: 0.9 }}
        transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
        className="relative isolate flex flex-col items-center gap-y-2 overflow-hidden bg-gray-50 px-4 py-2 sm:px-6 sm:py-3"
      >
        <div
          aria-hidden="true"
          className="absolute left-[max(-7rem,calc(50%-52rem))] top-1/2 -z-10 -translate-y-1/2 transform-gpu blur-2xl"
        >
          <div
            style={{
              clipPath:
                'polygon(74.8% 41.9%, 97.2% 73.2%, 100% 34.9%, 92.5% 0.4%, 87.5% 0%, 75% 28.6%, 58.5% 54.6%, 50.1% 56.8%, 46.9% 44%, 48.3% 17.4%, 24.7% 53.9%, 0% 27.9%, 11.9% 74.2%, 24.9% 54.1%, 68.6% 100%, 74.8% 41.9%)',
            }}
            className="aspect-[577/310] w-[36.0625rem] bg-gradient-to-r from-[#ff80b5] to-[#9089fc] opacity-30"
          />
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-center">
          <p className="text-sm leading-5 text-gray-900">
            <strong className="font-semibold">ALGORITHM Technologies Internships 2024</strong>
            <svg viewBox="0 0 2 2" aria-hidden="true" className="mx-1 inline h-0.5 w-0.5 fill-current">
              <circle r={1} cx={1} cy={1} />
            </svg>
            Join us to see what’s coming next.
          </p>
          <a
            href="/apply"
            className="flex-none rounded-full bg-gray-900 px-3 py-1 text-xs font-semibold text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
          >
            Apply now <span aria-hidden="true">&rarr;</span>
          </a>
          <button type="button" className="-m-2 p-2 focus-visible:outline-offset-[-4px]" onClick={handleDismiss}>
            <span className="sr-only">Dismiss</span>
            <XMarkIcon aria-hidden="true" className="h-4 w-4 text-gray-900" />
          </button>
        </div>
       
      </motion.div>
    )
  );
}
